module.exports = __webpack_public_path__ + "media/images/icon/tick-black-092bc686c0d346a2c713e7718842f6ee.svg";